import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RestService {

  constructor(private http: HttpClient) { }

	GET(url: string, headers: any = {}): Observable<any> {
		return this.http.get(url, headers);
	}

	POST(url: string, data: any, headers: any = {}): Observable<any> {
		return this.http.post(url, data, headers);
	}

	PUT(url: string, data: any): Observable<any> {
		return this.http.put(url, data);
	}

	PATCH(url: string, data: any, headers: any = {}): Observable<any> {
		return this.http.patch(url, data, headers);
	}

	DELETE(url: string, headers: any = {}): Observable<any> {
		return this.http.delete(url, headers);
	}

}
